import React, {ReactNode} from 'react';
import CheckOrderErrorLabel from "@CheckOrder/components/MainSection/CheckOrderErrorLabel";
import Checkbox from "./Checkbox";

interface TermWithCheckboxProps {
    onClick: (any?) => any,
    value: boolean,
    label?: string,
    errorLabelText?: string,
    userConfirmed?: boolean,
    children?: ReactNode,
}

const TermWithCheckbox = ({label, errorLabelText, userConfirmed, children, onClick, value}: TermWithCheckboxProps) => (
    <>
        <Checkbox onChange={onClick}>
            {children || (
                <span className="term-with-checkbox">
                    {label}
                </span>
            )}
        </Checkbox>
        {!value && userConfirmed && errorLabelText && (
            <CheckOrderErrorLabel error={errorLabelText}/>
        )}
    </>
)

export default TermWithCheckbox;